import {StoryDealCardType} from "@irati/types"

export interface CardRedemption {
  type: StoryDealCardType
  title: string
  text: string
  name?: string
  logo?: string
  redemptions?: number
  savings?: number
}

export const CARD_REDEMPTIONS: CardRedemption[] = [
  {
    type: StoryDealCardType.DealCardTypeAppleCrusader,
    title: "admin.components.yourPerkboxStory.redemptions.apple.title",
    text: "admin.components.yourPerkboxStory.redemptions.apple.text"
  },
  {
    type: StoryDealCardType.DealCardTypeCinemaConnoisseur,
    title: "admin.components.yourPerkboxStory.redemptions.cineworld.title",
    text: "admin.components.yourPerkboxStory.redemptions.cineworld.text"
  },
  {
    type: StoryDealCardType.DealCardTypeCoffeeHooray,
    title: "admin.components.yourPerkboxStory.redemptions.caffeNero.title",
    text: "admin.components.yourPerkboxStory.redemptions.caffeNero.text"
  },
  {
    type: StoryDealCardType.DealCardTypeFeastMode,
    title: "admin.components.yourPerkboxStory.redemptions.deliveroo.title",
    text: "admin.components.yourPerkboxStory.redemptions.deliveroo.text"
  },
  {
    type: StoryDealCardType.DealCardTypeOnlineShoppingPerfection,
    title: "admin.components.yourPerkboxStory.redemptions.amazon.title",
    text: "admin.components.yourPerkboxStory.redemptions.amazon.text"
  },
  {
    type: StoryDealCardType.DealCardTypeStreamingRoyalty,
    title: "admin.components.yourPerkboxStory.redemptions.rakuten.title",
    text: "admin.components.yourPerkboxStory.redemptions.rakuten.text"
  },
  {
    type: StoryDealCardType.DealCardTypeTechSaavy,
    title: "admin.components.yourPerkboxStory.redemptions.samsung.title",
    text: "admin.components.yourPerkboxStory.redemptions.samsung.text"
  },
  {
    type: StoryDealCardType.DealCardTypeTrolleyTakeover,
    title: "admin.components.yourPerkboxStory.redemptions.tesco.title",
    text: "admin.components.yourPerkboxStory.redemptions.tesco.text"
  },
  {
    type: StoryDealCardType.DealCardTypeWorkoutWarriors,
    title: "admin.components.yourPerkboxStory.redemptions.mygym.title",
    text: "admin.components.yourPerkboxStory.redemptions.mygym.text"
  },
  {
    type: StoryDealCardType.DealCardTypeBakery,
    title: "admin.components.yourPerkboxStory.redemptions.greggs.title",
    text: "admin.components.yourPerkboxStory.redemptions.greggs.text"
  },
  {
    type: StoryDealCardType.DealCardTypeTechConnoisseur,
    title: "admin.components.yourPerkboxStory.redemptions.currys.title",
    text: "admin.components.yourPerkboxStory.redemptions.currys.text"
  },
  {
    type: StoryDealCardType.DealCardTypeFashionistas,
    title: "admin.components.yourPerkboxStory.iconic.title",
    text: "admin.components.yourPerkboxStory.iconic.text"
  },
  {
    type: StoryDealCardType.DealCardTypeWanderlusters,
    title: "admin.components.yourPerkboxStory.hotelPlanner.title",
    text: "admin.components.yourPerkboxStory.hotelPlanner.text"
  }
]
